export default "__VITE_ASSET__CvFlKaEQ__"